module.exports = __webpack_public_path__ + "img/button.f5b75a4f.png";